// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  padding: 0 10px;
}

.toolbar {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 20px 20px;
  background: white;
  align-items: center;
  box-shadow: 0px -4px 15px 0px rgba(79, 97, 79, 0.2509803922);
}
.toolbar p {
  margin: 0px;
  color: var(--ion-color-secondary) !important;
}

.promo-info {
  align-items: center;
  padding: 10px 17px;
  background: white;
  margin: 10px 10px 0;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  font-size: 14px;
  display: none;
}
.promo-info .name {
  width: 180px;
}

.min-order {
  margin: 10px 10px 0;
}

.add-more {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 34px;
  min-width: -moz-fit-content;
  min-width: fit-content;
  padding-inline: 7px;
  cursor: pointer;
  border-radius: 22px;
  background-color: var(--ion-color-primary);
  padding: 10px;
}
.add-more .add-text {
  font-family: AppFontBold;
  font-size: 11px;
  line-height: 13px;
  letter-spacing: 0px;
  text-align: left;
  color: white;
}
.add-more .add-button {
  margin-right: 12px;
}

.card-actions {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.wrapper-block {
  height: calc(100% - 60px);
}
@media (max-width: 992px) {
  .wrapper-block .height-block {
    height: 100% !important;
  }
}

.wrapper {
  max-height: 100%;
  height: 100%;
}
.wrapper .border-line {
  border-radius: 26px;
  height: auto;
  max-height: auto;
  flex-direction: column;
  display: flex;
  background-size: cover;
  overflow: hidden;
  position: relative;
}
@media (max-width: 992px) {
  .wrapper .border-line {
    overflow: auto !important;
  }
}
@media (min-width: 991px) {
  .wrapper .border-line {
    height: calc(100% - 10px);
  }
}
.wrapper .border-line .cross-selector {
  position: absolute;
  top: 15px;
  right: 15px;
  margin: 0px;
  background: var(--color-white-accent);
  width: 35px;
  height: 35px;
  padding: 0px;
  z-index: 99;
  cursor: pointer;
}
.wrapper .border-line .cross-selector ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}
.wrapper .border-line .cross-selector:hover {
  background: #f2dbd9;
}
@media (max-width: 992px) {
  .wrapper .border-line {
    border-bottom: none;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
  }
}

.order-list {
  margin-block: 12px;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.order-list .add-articles {
  min-height: 42px;
  margin: 20px auto;
  width: max-content;
  min-width: 50%;
}
.order-list .add-articles .icon {
  width: 22px;
  height: 22px;
  background: white;
  border-radius: 50%;
  padding: 6px;
  display: flex;
  margin-right: 10px;
}
.order-list .add-articles .icon ion-icon {
  margin: auto;
  height: 100%;
}

.promo-code {
  width: 100%;
}

.article {
  text-align: center;
  height: 110px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (max-width: 992px) {
  .article {
    height: 35px;
  }
}

.ordered-articles {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
@media (max-width: 992px) {
  .ordered-articles {
    min-height: 150px;
  }
}

.ordered-articles-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 13px;
}

.title {
  font-family: AppFontBold;
  font-size: 25px;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: center;
  color: #000;
  margin-bottom: 18px;
}

.promo-error {
  margin: 10px;
  font-size: 13px;
  text-align: center;
  color: red;
  display: none;
}

.no-articles {
  display: flex;
}
.no-articles ion-icon {
  color: white;
  fill: white;
  margin-right: 10px;
  display: none;
}
@media (min-width: 991px) {
  .no-articles ion-icon {
    fill: black;
    color: black;
  }
}
@media (min-width: 991px) {
  .no-articles ion-icon.big-screen {
    display: block;
  }
}
@media (max-width: 992px) {
  .no-articles ion-icon.small-screen {
    display: block;
  }
}
.no-articles h3 {
  color: var(--color-black);
  font-family: AppFont;
  font-size: 16px;
}

.footer-finish-btn {
  padding: 10px 20px;
  margin: 0 20px;
}
.footer-finish-btn .footer-btn {
  width: 100%;
}

.border-top {
  border-top: 0.8px solid #fff;
}

.finish-btn {
  padding: 10px 20px;
  border-bottom: 1px solid #ebdfda;
}
@media (max-width: 992px) {
  .finish-btn {
    display: none;
  }
}
.finish-btn .footer-btn {
  width: 100%;
}
.finish-btn .footer-btn .footer-btn-text {
  font-size: 14px !important;
  color: white;
  font-family: AppFont, sans-serif;
}

.promo-section {
  border-top: 1px solid var(--color-black);
  border-bottom: 1px solid var(--color-black);
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
@media (max-width: 992px) {
  .promo-section {
    padding: 5px 20px;
  }
}
.promo-section.no-border {
  border-top: none;
}
.promo-section ion-icon {
  width: 30px;
  height: 30px;
}
.promo-section h3 {
  margin-left: 10px;
  font-size: 16px;
  font-family: AppFont, sans-serif;
  text-transform: uppercase;
}
@media (max-width: 992px) {
  .promo-section h3 {
    font-size: 14px;
  }
}

.tips {
  padding: 10px 20px 0px;
}

.kaisin-points {
  padding: 8px 15px;
}
.kaisin-points .wrapper-kaisin-block {
  background: #EBDFDA;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}
.kaisin-points .wrapper-kaisin-block .left-info {
  padding: 5px 20px;
  width: 60%;
  text-transform: uppercase;
}
.kaisin-points .wrapper-kaisin-block .left-info h3 {
  font-family: AppFontMedium;
  font-weight: bold;
  font-size: 14px;
}
.kaisin-points .wrapper-kaisin-block .left-info p {
  font-size: 10px;
  font-family: AppFont;
}
.kaisin-points .wrapper-kaisin-block .right-info {
  padding: 5px 20px;
  width: 40%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.kaisin-points .wrapper-kaisin-block .right-info ion-img {
  width: 50px;
  height: 50px;
}
.kaisin-points .wrapper-kaisin-block .right-info p {
  padding-right: 5px;
  font-weight: bold;
}
.kaisin-points .wrapper-kaisin-block .register-section {
  width: 100%;
  padding: 8px 10px;
  border-top: 1px solid var(--color-black);
  display: flex;
  justify-content: space-between;
}
.kaisin-points .wrapper-kaisin-block .register-section ion-button {
  --background: transparent;
  color: var(--color-black);
  min-height: 28px;
  font-size: 12px;
  width: 48%;
}

.delete-promo {
  justify-content: space-between;
}
.delete-promo .delete-items-section {
  display: flex;
  align-items: center;
}
.delete-promo .delete-items-section ion-icon {
  margin-left: 15px;
}

.form-section-input .form-section-title {
  padding-top: 15px;
  padding-bottom: 20px;
  border-top: 1px solid var(--color-black);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media (max-width: 992px) {
  .form-section-input .form-section-title {
    padding-top: 5px;
    padding-bottom: 5px;
  }
}
.form-section-input .form-section-title .rotate-icon {
  rotate: 0deg;
  transition: rotate 0.5s ease-in-out;
}
.form-section-input .form-section-title .rotate-icon.rotate {
  rotate: 180deg;
}
.form-section-input h3 {
  font-size: 16px;
  text-transform: uppercase;
  color: var(--color-black);
}
.form-section-input .input-forms {
  max-height: auto;
  height: -moz-fit-content;
  height: fit-content;
  transition: opacity 0.1s ease-in-out, max-height 0.5s cubic-bezier(0, 1, 0, 1);
}
.form-section-input .input-forms.hide {
  height: 0px;
  min-height: 0px;
  min-height: 0px;
  max-height: 0px;
  opacity: 0;
  overflow: hidden;
}
.form-section-input .input-forms .top-form-wrapper {
  padding: 0 16px;
}
.form-section-input .input-forms ion-label {
  font-family: AppFontSemiBold;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--color-black);
}
.form-section-input .input-forms .title-label {
  font-family: AppFontBold;
  font-size: 16px;
}

.address-selection {
  padding: 13px 20px;
}
.address-selection h3 {
  font-size: 14px;
}

.name_row {
  padding: 10px 10px 13px 15px;
  color: var(--color-black);
  display: flex;
  align-items: center;
  border-top: 1px solid var(--color-black);
  position: relative;
}
.name_row .coupon-val {
  color: var(--ion-color-primary);
  font-size: 13px;
  display: block;
  position: absolute;
  left: 15px;
  top: 35px;
}

.name-block b {
  font-family: AppFont, sans-serif;
  font-size: 14px;
  line-height: 20px;
  text-transform: uppercase;
  color: var(--ion-color-main);
}

.circle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
}
.circle ion-icon {
  width: 30px;
  height: 30px;
}

.error_container {
  margin: 0;
  margin-top: 5px;
  margin-bottom: 5px;
}

.added-gift {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 5px 20px;
  border-bottom: 1px solid var(--color-black);
  cursor: pointer;
}
.added-gift .header-gift {
  width: 35px;
  height: 35px;
  min-height: 35px;
  min-width: 35px;
  background: #F48B7F;
  border: 1px solid var(--color-black);
  border-radius: 50%;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.added-gift .inner-text-gift {
  margin-left: 5px;
}
.added-gift .inner-text-gift h3 {
  font-family: AppFontMedium;
  text-transform: uppercase;
  font-size: 12px;
}
.added-gift .inner-text-gift p {
  font-family: AppFontMedium;
  text-transform: uppercase;
  font-size: 12px;
}
.added-gift .delete-items-section {
  margin-left: auto;
}
.added-gift ion-icon {
  width: 25px;
  height: 25px;
}

.error-message {
  text-align: center;
  color: var(--ion-color-secondary);
  padding-bottom: 5px;
  font-size: 12px;
}

.add-gift-card {
  display: flex;
  align-items: center;
  padding: 10px 20px;
  cursor: pointer;
  border-bottom: 1px solid var(--color-black);
}
@media (max-width: 992px) {
  .add-gift-card {
    padding: 5px 20px;
  }
}
.add-gift-card ion-icon {
  width: 30px;
  height: 30px;
}
.add-gift-card .inner-text-gift h3 {
  font-family: AppFontMedium;
  text-transform: uppercase;
  font-size: 12px;
  color: var(--color-black);
}
.add-gift-card .inner-text-gift p {
  font-family: AppFontMedium;
  text-transform: uppercase;
  font-size: 12px;
}
.add-gift-card ion-img {
  width: 50px;
  margin-right: auto;
}
.add-gift-card .delete-items-section {
  margin-left: auto;
}

.total-points {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0px 20px;
  text-transform: uppercase;
}
.total-points span {
  color: #f48b7f;
  font-size: 12px;
}

ion-button.orange-btn {
  --background: #fc5e07;
  min-height: -moz-fit-content;
  min-height: fit-content;
  font-size: 12px;
  height: 20px;
}
ion-button.orange-btn span {
  text-transform: uppercase;
  color: #fff;
  padding: 0 10px;
}

.address-selection-text {
  color: var(--primary-btn);
}

.recommendations {
  margin-bottom: 20px;
}
.recommendations h5 {
  color: var(--accent-color);
  margin: 15px 20px;
}
.recommendations .recommendations-container {
  display: flex;
  overflow: scroll;
  padding: 0 15px;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.recommendations .recommendations-container::-webkit-scrollbar {
  display: none;
}
.recommendations .recommendation-article {
  height: 170px;
  margin: 0 3px;
  min-width: 110px;
  max-width: 130px;
}

:host ::ng-deep app-recommendation-article ion-button {
  font-size: 10px !important;
}

.promo-input-wrapper {
  padding-top: 15px;
  border-top: 1px solid var(--accent-color);
  border-radius: 24px;
}
.promo-input-wrapper .promo-input {
  margin: 0 20px;
  border-radius: 10px;
  min-height: 54px;
  padding: 0;
  --padding-start: 16px;
  --padding-end: 7px;
  --inner-padding-end: 0;
}
.promo-input-wrapper .promo-input ion-icon {
  margin-right: 12px;
  height: 34px;
  width: 34px;
}
.promo-input-wrapper .promo-input ion-input {
  min-height: 54px;
}
.promo-input-wrapper .promo-input ion-button {
  min-height: 40px;
  background: var(--accent-color);
  min-width: 130px;
}

.cutlery {
  --border-radius: 50%;
  --size: 20px;
  --checkbox-background-checked: var();
  --border-color-checked: var(--accent-color);
  --checkmark-color: var(--accent-color);
}`, "",{"version":3,"sources":["webpack://./src/app/components/order-content/order-content.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;AADF;;AAIA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,4DAAA;AADF;AAGE;EACE,WAAA;EACA,4CAAA;AADJ;;AAKA;EACE,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,0CAAA;EACA,kBAAA;EACA,eAAA;EAMA,aAAA;AAPF;AAGE;EACE,YAAA;AADJ;;AAOA;EACE,mBAAA;AAJF;;AAOA;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,YAAA;EACA,2BAAA;EAAA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,0CAAA;EACA,aAAA;AAJF;AAME;EACE,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;AAJJ;AAOE;EACE,kBAAA;AALJ;;AASA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AANF;;AASA;EACE,yBAAA;AANF;AC9DE;EDsEA;IAEI,uBAAA;EANJ;AACF;;AAUA;EACE,gBAAA;EAEA,YAAA;AARF;AAWE;EACE,mBAAA;EAEA,YAAA;EACA,gBAAA;EAQA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;AAjBJ;AClFE;EDmFA;IAMI,yBAAA;EAHJ;AACF;AC7FE;EDyFA;IASI,yBAAA;EADJ;AACF;AASI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;AAPN;AASM;EACE,WAAA;EACA,YAAA;EACA,WAAA;AAPR;AAUM;EACE,mBAAA;AARR;AChHE;EDmFA;IA8CI,mBAAA;IACA,8BAAA;IACA,+BAAA;EAbJ;AACF;;AAiBA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;AAdF;AAgBE;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAdJ;AAgBI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AAdN;AAgBM;EACE,YAAA;EACA,YAAA;AAdR;;AAqBA;EACE,WAAA;AAlBF;;AAqBA;EACE,kBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAlBF;AC7JE;ED0KF;IAOI,YAAA;EAhBF;AACF;;AAmBA;EACE,OAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAhBF;AC1KE;EDqLF;IAOI,iBAAA;EAdF;AACF;;AAiBA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EAEA,mBAAA;AAfF;;AAkBA;EACE,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;AAfF;;AAkBA;EACE,YAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;AAfF;;AAkBA;EACE,aAAA;AAfF;AAiBE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EAMA,aAAA;AApBJ;ACzNE;EDoOA;IAMI,WAAA;IACA,YAAA;EAbJ;AACF;AC/NE;ED+OE;IAEI,cAAA;EAdN;AACF;AC9NE;ED+OE;IAEI,cAAA;EAfN;AACF;AAmBE;EACE,yBAAA;EACA,oBAAA;EACA,eAAA;AAjBJ;;AAqBA;EACE,kBAAA;EACA,cAAA;AAlBF;AAoBE;EACE,WAAA;AAlBJ;;AAsBA;EACE,4BAAA;AAnBF;;AAsBA;EACE,kBAAA;EAeA,gCAAA;AAjCF;ACzPE;ED0QF;IAGI,aAAA;EAhBF;AACF;AAkBE;EACE,WAAA;AAhBJ;AAkBI;EACE,0BAAA;EACA,YAAA;EACA,gCAAA;AAhBN;;AAuBA;EACE,wCAAA;EACA,2CAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;AApBF;AC/QE;ED6RF;IAQI,iBAAA;EAlBF;AACF;AAoBE;EACE,gBAAA;AAlBJ;AAqBE;EACE,WAAA;EACA,YAAA;AAnBJ;AAsBE;EACE,iBAAA;EACA,eAAA;EACA,gCAAA;EACA,yBAAA;AApBJ;ACjSE;EDiTA;IAMI,eAAA;EAlBJ;AACF;;AAuBA;EACE,sBAAA;AApBF;;AAuBA;EACE,iBAAA;AApBF;AAsBE;EACE,mBAAA;EACA,mBAAA;EAEA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;AArBJ;AAuBI;EACE,iBAAA;EACA,UAAA;EACA,yBAAA;AArBN;AAuBM;EACE,0BAAA;EACA,iBAAA;EACA,eAAA;AArBR;AAwBM;EACE,eAAA;EACA,oBAAA;AAtBR;AA2BI;EACE,iBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AAzBN;AA2BM;EACE,WAAA;EACA,YAAA;AAzBR;AA4BM;EACE,kBAAA;EACA,iBAAA;AA1BR;AA8BI;EACE,WAAA;EACA,iBAAA;EACA,wCAAA;EACA,aAAA;EACA,8BAAA;AA5BN;AA8BM;EACE,yBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;AA5BR;;AAkCA;EACE,8BAAA;AA/BF;AAiCE;EACE,aAAA;EACA,mBAAA;AA/BJ;AAiCI;EACE,iBAAA;AA/BN;;AAqCE;EACE,iBAAA;EACA,oBAAA;EACA,wCAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAlCJ;ACrXE;EDiZA;IASI,gBAAA;IACA,mBAAA;EAjCJ;AACF;AAmCI;EACE,YAAA;EACA,mCAAA;AAjCN;AAmCM;EACE,cAAA;AAjCR;AAsCE;EACE,eAAA;EACA,yBAAA;EACA,yBAAA;AApCJ;AAuCE;EACE,gBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,8EAAA;AArCJ;AAuCI;EACE,WAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,gBAAA;AArCN;AAyCI;EACE,eAAA;AAvCN;AA0CI;EACE,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,yBAAA;AAxCN;AA2CI;EACE,wBAAA;EACA,eAAA;AAzCN;;AA8CA;EACE,kBAAA;AA3CF;AA6CE;EACE,eAAA;AA3CJ;;AAgDA;EACE,4BAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,wCAAA;EACA,kBAAA;AA7CF;AA+CE;EACE,+BAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;AA7CJ;;AAmDE;EACE,gCAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,4BAAA;AAhDJ;;AAoDA;EAEE,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,WAAA;EACA,YAAA;AAnDF;AAqDE;EACE,WAAA;EACA,YAAA;AAnDJ;;AAuDA;EACE,SAAA;EACA,eAAA;EACA,kBAAA;AApDF;;AAwDA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,iBAAA;EACA,2CAAA;EACA,eAAA;AArDF;AAuDE;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AArDJ;AAwDE;EACE,gBAAA;AAtDJ;AAwDI;EACE,0BAAA;EACA,yBAAA;EACA,eAAA;AAtDN;AAyDI;EACE,0BAAA;EACA,yBAAA;EACA,eAAA;AAvDN;AA2DE;EACE,iBAAA;AAzDJ;AA4DE;EACE,WAAA;EACA,YAAA;AA1DJ;;AA8DA;EACE,kBAAA;EACA,iCAAA;EACA,mBAAA;EACA,eAAA;AA3DF;;AA8DA;EACE,aAAA;EACA,mBAAA;EAEA,kBAAA;EACA,eAAA;EACA,2CAAA;AA5DF;AC/gBE;EDqkBF;IAQI,iBAAA;EA1DF;AACF;AA4DE;EACE,WAAA;EACA,YAAA;AA1DJ;AA8DI;EACE,0BAAA;EACA,yBAAA;EACA,eAAA;EACA,yBAAA;AA5DN;AA+DI;EACE,0BAAA;EACA,yBAAA;EACA,eAAA;AA7DN;AAiEE;EACE,WAAA;EACA,kBAAA;AA/DJ;AAkEE;EACE,iBAAA;AAhEJ;;AAoEA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,yBAAA;AAjEF;AAmEE;EACE,cAAA;EACA,eAAA;AAjEJ;;AAqEA;EACE,qBAAA;EACA,4BAAA;EAAA,uBAAA;EACA,eAAA;EACA,YAAA;AAlEF;AAoEE;EACE,yBAAA;EACA,WAAA;EACA,eAAA;AAlEJ;;AAsEA;EACE,yBAAA;AAnEF;;AAuEA;EAuBE,mBAAA;AA1FF;AAoEE;EACE,0BAAA;EACA,iBAAA;AAlEJ;AAqEE;EACE,aAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,wBAAA;AAnEJ;AAoEI;EACE,aAAA;AAlEN;AAsEE;EACE,aAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AApEJ;;AAyEA;EACE,0BAAA;AAtEF;;AAyEA;EACE,iBAAA;EACA,yCAAA;EACA,mBAAA;AAtEF;AAuEE;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;EACA,qBAAA;EACA,kBAAA;EACA,sBAAA;AArEJ;AAuEI;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AArEN;AAuEI;EACE,gBAAA;AArEN;AAuEI;EACE,gBAAA;EACA,+BAAA;EACA,gBAAA;AArEN;;AA0EA;EACE,oBAAA;EACA,YAAA;EACA,oCAAA;EACA,2CAAA;EACA,sCAAA;AAvEF","sourcesContent":["@import '../../../theme/mixins';\n\nion-content {\n  padding: 0 10px;\n}\n\n.toolbar {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  padding: 20px 20px;\n  background: white;\n  align-items: center;\n  box-shadow: 0px -4px 15px 0px #4f614f40;\n\n  p {\n    margin: 0px;\n    color: var(--ion-color-secondary) !important;\n  }\n}\n\n.promo-info {\n  align-items: center;\n  padding: 10px 17px;\n  background: white;\n  margin: 10px 10px 0;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);\n  border-radius: 4px;\n  font-size: 14px;\n\n  .name {\n    width: 180px;\n  }\n\n  display: none;\n}\n\n.min-order {\n  margin: 10px 10px 0;\n}\n\n.add-more {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  height: 34px;\n  min-width: fit-content;\n  padding-inline: 7px;\n  cursor: pointer;\n  border-radius: 22px;\n  background-color: var(--ion-color-primary);\n  padding: 10px;\n\n  .add-text {\n    font-family: AppFontBold;\n    font-size: 11px;\n    line-height: 13px;\n    letter-spacing: 0px;\n    text-align: left;\n    color: white;\n  }\n\n  .add-button {\n    margin-right: 12px;\n  }\n}\n\n.card-actions {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.wrapper-block {\n  height: calc(100% - 60px);\n\n  .height-block {\n    @include mobile {\n      height: 100% !important;\n    }\n  }\n}\n\n.wrapper {\n  max-height: 100%;\n\n  height: 100%;\n  // padding: 20px;\n  // display: flex;\n  .border-line {\n    border-radius: 26px;\n\n    height: auto;\n    max-height: auto;\n    @include mobile {\n      overflow: auto !important;\n    }\n    @include desktop {\n      height: calc(100% - 10px);\n    }\n    // flex-grow: 1;\n    flex-direction: column;\n    display: flex;\n    background-size: cover;\n    overflow: hidden;\n    position: relative;\n\n    .cross-selector {\n      position: absolute;\n      top: 15px;\n      right: 15px;\n      margin: 0px;\n      background: var(--color-white-accent);\n      width: 35px;\n      height: 35px;\n      padding: 0px;\n      z-index: 99;\n      cursor: pointer;\n\n      ion-icon {\n        width: 100%;\n        height: 100%;\n        margin: 0px;\n      }\n\n      &:hover {\n        background: #f2dbd9;\n      }\n\n      // @include desktop {\n      // \tdisplay: none;\n      // }\n    }\n\n    @include mobile {\n      border-bottom: none;\n      border-bottom-left-radius: 0px;\n      border-bottom-right-radius: 0px;\n    }\n  }\n}\n\n.order-list {\n  margin-block: 12px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n\n  .add-articles {\n    min-height: 42px;\n    margin: 20px auto;\n    width: max-content;\n    min-width: 50%;\n\n    .icon {\n      width: 22px;\n      height: 22px;\n      background: white;\n      border-radius: 50%;\n      padding: 6px;\n      display: flex;\n      margin-right: 10px;\n\n      ion-icon {\n        margin: auto;\n        height: 100%;\n      }\n    }\n\n  }\n}\n\n.promo-code {\n  width: 100%;\n}\n\n.article {\n  text-align: center;\n  height: 110px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  @include mobile {\n    height: 35px;\n  }\n}\n\n.ordered-articles {\n  flex: 1;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  @include mobile {\n    min-height: 150px;\n  }\n}\n\n.ordered-articles-container {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  margin-bottom: 13px;\n}\n\n.title {\n  font-family: AppFontBold;\n  font-size: 25px;\n  line-height: 21px;\n  letter-spacing: 0em;\n  text-align: center;\n  color: #000;\n  margin-bottom: 18px;\n}\n\n.promo-error {\n  margin: 10px;\n  font-size: 13px;\n  text-align: center;\n  color: red;\n  display: none;\n}\n\n.no-articles {\n  display: flex;\n\n  ion-icon {\n    color: white;\n    fill: white;\n    margin-right: 10px;\n\n    @include desktop {\n      fill: black;\n      color: black;\n    }\n    display: none;\n\n    &.big-screen {\n      @include desktop {\n        display: block;\n      }\n    }\n\n    &.small-screen {\n      @include mobile {\n        display: block;\n      }\n    }\n  }\n\n  h3 {\n    color: var(--color-black);\n    font-family: AppFont;\n    font-size: 16px;\n  }\n}\n\n.footer-finish-btn {\n  padding: 10px 20px;\n  margin: 0 20px;\n\n  .footer-btn {\n    width: 100%;\n  }\n}\n\n.border-top {\n  border-top: .8px solid #fff;\n}\n\n.finish-btn {\n  padding: 10px 20px;\n  @include mobile {\n    display: none;\n  }\n\n  .footer-btn {\n    width: 100%;\n\n    .footer-btn-text {\n      font-size: 14px !important;\n      color: white;\n      font-family: AppFont, sans-serif;\n    }\n  }\n\n  border-bottom: 1px solid #ebdfda;\n}\n\n.promo-section {\n  border-top: 1px solid var(--color-black);\n  border-bottom: 1px solid var(--color-black);\n  padding: 10px 20px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  @include mobile {\n    padding: 5px 20px;\n  }\n\n  &.no-border {\n    border-top: none;\n  }\n\n  ion-icon {\n    width: 30px;\n    height: 30px;\n  }\n\n  h3 {\n    margin-left: 10px;\n    font-size: 16px;\n    font-family: AppFont, sans-serif;\n    text-transform: uppercase;\n    @include mobile {\n      font-size: 14px;\n    }\n  }\n\n}\n\n.tips {\n  padding: 10px 20px 0px;\n}\n\n.kaisin-points {\n  padding: 8px 15px;\n\n  .wrapper-kaisin-block {\n    background: #EBDFDA;\n    border-radius: 18px;\n\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n\n    .left-info {\n      padding: 5px 20px;\n      width: 60%;\n      text-transform: uppercase;\n\n      h3 {\n        font-family: AppFontMedium;\n        font-weight: bold;\n        font-size: 14px;\n      }\n\n      p {\n        font-size: 10px;\n        font-family: AppFont;\n\n      }\n    }\n\n    .right-info {\n      padding: 5px 20px;\n      width: 40%;\n      display: flex;\n      align-items: center;\n      justify-content: flex-end;\n\n      ion-img {\n        width: 50px;\n        height: 50px;\n      }\n\n      p {\n        padding-right: 5px;\n        font-weight: bold;\n      }\n    }\n\n    .register-section {\n      width: 100%;\n      padding: 8px 10px;\n      border-top: 1px solid var(--color-black);\n      display: flex;\n      justify-content: space-between;\n\n      ion-button {\n        --background: transparent;\n        color: var(--color-black);\n        min-height: 28px;\n        font-size: 12px;\n        width: 48%;\n      }\n    }\n  }\n}\n\n.delete-promo {\n  justify-content: space-between;\n\n  .delete-items-section {\n    display: flex;\n    align-items: center;\n\n    ion-icon {\n      margin-left: 15px;\n    }\n  }\n}\n\n.form-section-input {\n  .form-section-title {\n    padding-top: 15px;\n    padding-bottom: 20px;\n    border-top: 1px solid var(--color-black);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    @include mobile {\n      padding-top: 5px;\n      padding-bottom: 5px;\n    }\n\n    .rotate-icon {\n      rotate: 0deg;\n      transition: rotate 0.5s ease-in-out;\n\n      &.rotate {\n        rotate: 180deg;\n      }\n    }\n  }\n\n  h3 {\n    font-size: 16px;\n    text-transform: uppercase;\n    color: var(--color-black);\n  }\n\n  .input-forms {\n    max-height: auto;\n    height: fit-content;\n    transition: opacity 0.1s ease-in-out, max-height 0.5s cubic-bezier(0, 1, 0, 1);\n\n    &.hide {\n      height: 0px;\n      min-height: 0px;\n      min-height: 0px;\n      max-height: 0px;\n      opacity: 0;\n      overflow: hidden;\n    }\n\n\n    .top-form-wrapper {\n      padding: 0 16px;\n    }\n\n    ion-label {\n      font-family: AppFontSemiBold;\n      font-size: 14px;\n      line-height: 120%;\n      letter-spacing: 0.08em;\n      text-transform: uppercase;\n      color: var(--color-black);\n    }\n\n    .title-label {\n      font-family: AppFontBold;\n      font-size: 16px;\n    }\n  }\n}\n\n.address-selection {\n  padding: 13px 20px;\n\n  h3 {\n    font-size: 14px;\n  }\n}\n\n\n.name_row {\n  padding: 10px 10px 13px 15px;\n  color: var(--color-black);\n  display: flex;\n  align-items: center;\n  border-top: 1px solid var(--color-black);\n  position: relative;\n\n  .coupon-val {\n    color: var(--ion-color-primary);\n    font-size: 13px;\n    display: block;\n    position: absolute;\n    left: 15px;\n    top: 35px\n  }\n}\n\n.name-block {\n\n  b {\n    font-family: AppFont, sans-serif;\n    font-size: 14px;\n    line-height: 20px;\n    text-transform: uppercase;\n    color: var(--ion-color-main);\n  }\n}\n\n.circle {\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  width: 30px;\n  height: 30px;\n\n  ion-icon {\n    width: 30px;\n    height: 30px;\n  }\n}\n\n.error_container {\n  margin: 0;\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n\n\n.added-gift {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 5px 20px;\n  border-bottom: 1px solid var(--color-black);\n  cursor: pointer;\n\n  .header-gift {\n    width: 35px;\n    height: 35px;\n    min-height: 35px;\n    min-width: 35px;\n    background: #F48B7F;\n    border: 1px solid var(--color-black);\n    border-radius: 50%;\n    font-size: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n  }\n\n  .inner-text-gift {\n    margin-left: 5px;\n\n    h3 {\n      font-family: AppFontMedium;\n      text-transform: uppercase;\n      font-size: 12px;\n    }\n\n    p {\n      font-family: AppFontMedium;\n      text-transform: uppercase;\n      font-size: 12px;\n    }\n  }\n\n  .delete-items-section {\n    margin-left: auto;\n  }\n\n  ion-icon {\n    width: 25px;\n    height: 25px;\n  }\n}\n\n.error-message {\n  text-align: center;\n  color: var(--ion-color-secondary);\n  padding-bottom: 5px;\n  font-size: 12px;\n}\n\n.add-gift-card {\n  display: flex;\n  align-items: center;\n  // justify-content: flex-start;\n  padding: 10px 20px;\n  cursor: pointer;\n  border-bottom: 1px solid var(--color-black);\n  @include mobile {\n    padding: 5px 20px;\n  }\n\n  ion-icon {\n    width: 30px;\n    height: 30px;\n  }\n\n  .inner-text-gift {\n    h3 {\n      font-family: AppFontMedium;\n      text-transform: uppercase;\n      font-size: 12px;\n      color: var(--color-black);\n    }\n\n    p {\n      font-family: AppFontMedium;\n      text-transform: uppercase;\n      font-size: 12px;\n    }\n  }\n\n  ion-img {\n    width: 50px;\n    margin-right: auto;\n  }\n\n  .delete-items-section {\n    margin-left: auto;\n  }\n}\n\n.total-points {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  padding: 0px 20px;\n  text-transform: uppercase;\n\n  span {\n    color: #f48b7f;\n    font-size: 12px;\n  }\n}\n\nion-button.orange-btn {\n  --background: #fc5e07;\n  min-height: fit-content;\n  font-size: 12px;\n  height: 20px;\n\n  & span {\n    text-transform: uppercase;\n    color: #fff;\n    padding: 0 10px;\n  }\n}\n\n.address-selection-text {\n  color: var(--primary-btn);\n}\n\n\n.recommendations {\n  h5 {\n    color: var(--accent-color);\n    margin: 15px 20px;\n  }\n\n  .recommendations-container {\n    display: flex;\n    overflow: scroll;\n    padding: 0 15px;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n\n  .recommendation-article {\n    height: 170px;\n    margin: 0 3px;\n    min-width: 110px;\n    max-width: 130px;\n  }\n  margin-bottom: 20px;\n}\n\n:host ::ng-deep app-recommendation-article ion-button {\n  font-size: 10px!important;\n}\n\n.promo-input-wrapper {\n  padding-top: 15px;\n  border-top: 1px solid var(--accent-color);\n  border-radius: 24px;\n  .promo-input {\n    margin: 0 20px;\n    border-radius: 10px;\n    min-height: 54px;\n    padding: 0;\n    --padding-start: 16px;\n    --padding-end: 7px;\n    --inner-padding-end: 0;\n\n    ion-icon {\n      margin-right: 12px;\n      height: 34px;\n      width: 34px;\n    }\n    ion-input {\n      min-height: 54px;\n    }\n    ion-button {\n      min-height: 40px;\n      background: var(--accent-color);\n      min-width: 130px;\n    }\n  }\n}\n\n.cutlery {\n  --border-radius: 50%;\n  --size: 20px;\n  --checkbox-background-checked: var();\n  --border-color-checked: var(--accent-color);\n  --checkmark-color: var(--accent-color);\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
